import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {GameHeader} from "../games-list/components/game-header";
import {EntityHeader} from "./entity-header";
import {GameCardViewModel} from "../game-card/view-models/game-card.view-model";
import {ACTION_TYPES} from "../../consts";
import {APP} from "../../app/consts";

export class GroupedListsGroupHeaderEntityProps extends BaseProps {
}

export const GroupEntityHeader = observer(({entity, title, controller, className, source}: GroupedListsGroupHeaderEntityProps) => {
  const shouldRenderGameHeader = entity instanceof GameCardViewModel

  const gameProps = {
    game: entity,
    className,
    controller
  }

  const entityProps = {
    entity,
    className,
    title,
    onClick: () => {
      controller.action(ACTION_TYPES.entityClick, {
        entityId: entity.id,
        entityName: entity.nameForURL,
        entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[entity.objectType],
        source,
        sportTypeId: entity.sport.id,
        currentLinkModel: controller.state.currentLinkModel
      })

      return true
    }
  }

  return shouldRenderGameHeader ? <GameHeader {...gameProps}/> : <EntityHeader {...entityProps}/>
});
